module.exports = __webpack_public_path__ + "img/eprivado.4807d783.svg";